import { render } from "./UserMobileMenu.vue?vue&type=template&id=754904b2"
import script from "./UserMobileMenu.vue?vue&type=script&lang=js"
export * from "./UserMobileMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__